import React from 'react';

export default function PriorityLevel({ priorityLevel, ...props }) {
    return (
        <div className="priority-level" {...props}>
            {priorityLevel}
        </div>
    );
}
